import { useState,useEffect } from "react";
import "./styles/Individuals.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter,formatValue } from "../../utils/utils";
import LoadSimple from "../LoadSimple";
// Registrar componentes de Chart.js

const WorkStation = ({handleShowPopup,server,languaje,mode,setHostSelected,hostSelected,openAddHostModal,showHistoric}) => {
  // const [hostSelected,setHostSelected]=useState({})
  // const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  // function openAddHostModal() {

  //   //   console.log('open')
  //     setAddHostModalOpen(true);
  //   }

  //   function closeAddHostModal() {

  //       setAddHostModalOpen(false);
  //   }
  const [workStations, setWorkStations] = useState([]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const newWorkStations = generateWorkStations(10); // Genera 5 estaciones de trabajo con valores aleatorios
  //     setWorkStations(newWorkStations);
  //   }, 2000); // Actualiza cada 2 segundos

  //   return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
  // }, []);
  // useEffect(()=>{
  //   search_data()
  //   // setInterval(search_data, 10000);
  // },[])
  useEffect(() => {
    search_data()
    const intervalId = setInterval(() => {
      search_data()
        // Tu lógica aquí
    }, 180000);

    // Cleanup para detener el intervalo al desmontar el componente
    return () => {
      clearInterval(intervalId);
    };
}, []);
  const token_item=localStorage.getItem('access_token')
  const [dataPrinter,setDataPrinter]=useState({data:{},loading:true,error:{}})
  function search_data(){
    setDataPrinter({data:dataPrinter.data,loading:true,error:dataPrinter.error})
      const fetchData = async () => {
        // console.log(server.url+'/api/v1/cassia/diagnosta/'+data.ip)
        try {
          const response = await fetch(server.url+'/api/v1/cassia/dashboard/hosts_metrics/33', {                 
                                 headers: {
                                   'Content-Type': 'application/json',
                                   Authorization: `Bearer ${token_item}`,
                                 },
                               });
          // console.log(response)
          if (response.ok) {
            const response_data = await response.json();

            setDataPrinter({data:response_data.message,loading:false,error:dataPrinter.error})

            // setDataAnalisis(response_data.data)
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
        //   setInternalError(true)
        }
      };
      fetchData();
  }
  const generateWorkStations = (count) => {
    return Array.from({ length: count }, (_, index) => {
      const metrics = Array.from({ length: 4 }, () => Math.floor(Math.random() * 100)); // Valores aleatorios para las métricas

      return (
        <div className="cont-globe">
        <div className="globe-info" key={index}>
          <div className="globe-title-info titleIndividuals">
            {`Printer ${index + 1}`}
          </div>
          <div className="globe-body-info" style={{ display: 'block', height: '90%', overflow: 'auto' }}>
            {metrics.map((metricValue, metricIndex) => (
              <div className="globe-title-info individualsInfo" key={metricIndex}>
                <div className="txt-info-individual">
                  {`Metrica ${metricIndex + 1}`}
                </div>
                <div className="value-info-individual" style={{color:((metricValue<30)?'var(--red-alert)':'var(--green)')}}>
                  {metricValue}
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>
      );
    });
  };

  return (
  <>
      <div className="main-cont-graf-monitor">
          <div className="compact-graf-monitor">
            {

            (dataPrinter.loading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'100%'}}><LoadSimple></LoadSimple></div>:
            <section class='FlexContainerIndividuals'>
          {/* {workStations} */}
          {
             (dataPrinter.data.length==0 && dataPrinter.loading==false)?
             <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'100%',color:'var(--txt-color)'}}>Sin resultados</div>
           :
            dataPrinter.data.map((element,index)=>(
              <div className="cont-globe">
                          <div className="globe-info">
                              <div className="globe-title-info titleIndividuals  tooltip-container-individuals">
                                  {element.hostname}
                                  {/* {'Bosques_Demo_Printer_Kyocera_TASKALFA 3051ci_PISO5'} */}
                              </div>
                             
                              <div className="globe-body-info" style={{display:'block',height:'90%',overflow:'auto'}}>
                                  <div className="globe-title-info individualsInfo" style={{width:'100%',height:'9%'}} >
                                      <div className="txt-info-individual"  style={{width:'50%',left:'0%',textAlign:'center',display:'flex',justifyContent:'center',color:'var(--third-color)'}}>
                                    {'IP:  '+element.ip}
                                      </div>
                                      <div className="txt-info-individual"  style={{width:'50%',left:'0%',textAlign:'center',display:'flex',justifyContent:'center',color:'var(--txt-color)'}}>
                                    {'('+element.metrics.length+')  metricas capturadas'}
                                      </div>
                                  </div>
                                  <div className="cont-list-metrics">
                                  {
                                    (element.metrics.length==0)?
                                    <div className="globe-title-info individualsInfo" >
                                      <div className="txt-info-individual">
                                          Sin metricas
                                      </div>
                                  </div>:
                                  element.metrics.map((metric,indice)=>(
                                    <div className="globe-title-info individualsInfo" >
                                      <div className="txt-info-individual">
                                          {metric.name}
                                      </div>
                                      <div className="value-info-individual" style={{color:((metric.danger==1)?'var(--red-alert)':'var(--green)')}}>
                                          {(typeof metric.value === 'string')?metric.value:formatValue(metric.value)+" "+metric.units}
                                      </div>
                                  </div>
                                  ))
                                  }
                                  </div>
                                  <div className="globe-title-info individualsInfo cont-btn-historical" style={{width:'100%',height:'10%'}} onClick={()=>{showHistoric(element)}}>
                                  <div className="txt-info-individual"  style={{width:'10%',color:'var(--main-color)',left:'0%',textAlign:'center',display:'flex',justifyContent:'center'}}>
                                  <img
                                  style={{width:'40%'}}
                      src={
                        "/iconos/grafic_line.png" 
                      }
                      name="provicionamiento"
                    />
                                      </div>
                                      
                                      <div className="txt-info-individual"  style={{width:'auto',color:'var(--main-color)',left:'0%',textAlign:'center',display:'flex',justifyContent:'center'}}>
                                    {'Ver Detalles'}
                                      </div>
                                      
                                  </div>
                              </div>
                              
                          </div>
                      </div>
            ))
            
             
          }
          
          {/* <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div> */}
      </section>
      }
          </div>
      </div>
  </>
  );
};

export default WorkStation;
